var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcome1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "219px",
    height: "219px",
    viewBox: "0 0 219 219",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Third-ideation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "final",
    transform: "translate(-373.000000, -401.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(373.000000, 401.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#978EED",
    x: -1.42108547e-14,
    y: 0,
    width: 219,
    height: 219
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-27-Copy",
    transform: "translate(37.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-78",
    stroke: "#23506A",
    strokeWidth: 0.65,
    fill: "#EAF6F9",
    x: 0.325,
    y: 113.325,
    width: 143.35,
    height: 18.35,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-80",
    stroke: "#23506A",
    strokeWidth: 0.65,
    fill: "#EAF6F9",
    x: 0.325,
    y: 62.325,
    width: 143.35,
    height: 18.35,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-81",
    stroke: "#23506A",
    strokeWidth: 0.65,
    fill: "#EAF6F9",
    x: 0.325,
    y: 86.325,
    width: 143.35,
    height: 18.35,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.576923,
    y1: 122.5,
    x2: 22.9999994,
    y2: 122.5,
    id: "Path-5-Copy-29",
    stroke: "#23506A",
    strokeWidth: 2.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.576923,
    y1: 71.5,
    x2: 22.9999994,
    y2: 71.5,
    id: "Path-5-Copy-30",
    stroke: "#23506A",
    strokeWidth: 2.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.576923,
    y1: 95.5,
    x2: 22.9999994,
    y2: 95.5,
    id: "Path-5-Copy-31",
    stroke: "#23506A",
    strokeWidth: 2.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0042806,128.807468 C54.5227912,130.624707 55.4235185,132.148734 56.6239621,133.349178 C57.8614141,134.58663 59.4217298,135.48355 61.2241505,135.996947 C59.4049692,136.510627 57.8545861,137.409725 56.6301582,138.634153 C55.4016681,139.862643 54.4973402,141.422423 53.9848307,143.262571 C53.4548675,141.459886 52.5356871,139.926729 51.319413,138.710455 C50.0720314,137.463074 48.5087922,136.546532 46.7219314,136.018999 C48.5544476,135.512906 50.1396,134.615133 51.3924763,133.362257 C52.5904965,132.164236 53.4891514,130.6383 54.0042806,128.807468 Z",
    id: "Polygon-Copy-13",
    stroke: "#29556E",
    fill: "#EDB649"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-82",
    stroke: "#23506A",
    strokeWidth: 0.65,
    fill: "#EAF6F9",
    x: 0.325,
    y: 37.325,
    width: 143.35,
    height: 18.35,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-87",
    stroke: "#23506A",
    strokeWidth: 0.65,
    fill: "#6BBFD6",
    x: 0.325,
    y: 21.325,
    width: 143.35,
    height: 8.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.576923,
    y1: 46.5,
    x2: 22.9999994,
    y2: 46.5,
    id: "Path-5-Copy-32",
    stroke: "#23506A",
    strokeWidth: 2.65
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-83",
    stroke: "#23506A",
    strokeWidth: 0.65,
    fill: "#EAF6F9",
    x: 6.325,
    y: 42.325,
    width: 7.35,
    height: 7.35,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-84",
    stroke: "#23506A",
    strokeWidth: 0.65,
    fill: "#EAF6F9",
    x: 6.325,
    y: 118.325,
    width: 7.35,
    height: 7.35,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-85",
    stroke: "#23506A",
    strokeWidth: 0.65,
    fill: "#EAF6F9",
    x: 6.325,
    y: 67.325,
    width: 7.35,
    height: 7.35,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-86",
    stroke: "#23506A",
    strokeWidth: 0.65,
    fill: "#EAF6F9",
    x: 6.325,
    y: 92.325,
    width: 7.35,
    height: 7.35,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5047659,4.982602 C22.2725833,8.56920113 23.8878783,11.5345316 26.1540863,13.8007397 C28.4932734,16.1399267 31.5317036,17.7385687 35.0674058,18.4964668 C31.4914499,19.2544272 28.4759192,20.8598139 26.164507,23.1712261 C23.851226,25.4845071 22.2380645,28.5098841 21.4838548,32.1195514 C20.6978569,28.5747101 19.0462291,25.5951003 16.750681,23.2995522 C14.3922923,20.9411635 11.3498325,19.3015845 7.85380666,18.5204383 C11.4351851,17.7777263 14.5121172,16.184179 16.8735602,13.822736 C19.1331246,11.5631716 20.743399,8.59633804 21.5047659,4.982602 Z",
    id: "Polygon-Copy-14",
    stroke: "#29556E",
    fill: "#EDB649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.00485,45.9379487 C134.976293,51.3973521 137.312064,55.8801553 140.684211,59.2523017 C144.167367,62.7354577 148.762787,65.0385619 154.126397,65.9962183 C148.695738,66.9535239 144.138087,69.2690679 140.698856,72.7082989 C137.261039,76.1461156 134.934892,80.7122882 133.983409,86.189852 C132.988106,80.8051437 130.59712,76.3038204 127.181949,72.888649 C123.670092,69.3767924 119.070209,67.0097916 113.774272,66.0211874 C119.196893,65.0856698 123.843252,62.7946076 127.354644,59.2832155 C130.714913,55.9229465 133.042391,51.4403534 134.00485,45.9379487 Z",
    id: "Polygon-Copy-15",
    stroke: "#29556E",
    fill: "#EDB649"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome1);
export default __webpack_public_path__ + "static/media/Welcome1.8aa23ecc8e861a1790df143b3ddf4a60.svg";
export { ForwardRef as ReactComponent };